export default __webpack_public_path__ + "static/media/cert-hkgcsmeaa.10566f0e.jpg";